import * as THREE from 'three'
import gsap from 'gsap'
import { onModelProgress } from '../three/utils/RecordModel'

/**
 * First-load screen: the logo fills with colour as three's loaders (model, covers,
 * wear photo) report progress, then the screen fades out. Markup in partials/loader.twig.
 */
export default class Loader {
	constructor() {
		this.el = document.querySelector('[data-loader]')
		this.total = 0 // items the loading manager knows about
		this.fill = this.el?.querySelector('[data-loader-fill]')
		this.shown = { value: 0 } // eased fill, 0..1
		this.target = 0
		this.fillDuration = 0.6
		this.outDuration = 0.5

		// the manager counts items; the model's bytes count as a few more so the big download shows
		const manager = THREE.DefaultLoadingManager
		const modelWeight = 4
		let items = 0
		let model = 0
		const update = () => this.#progress((items + modelWeight * model) / (this.total + modelWeight))
		manager.onProgress = (url, loaded, total) => ((items = loaded), (this.total = total), update())
		onModelProgress(fraction => ((model = fraction), update()))
		this.loaded = new Promise(resolve => (manager.onLoad = resolve))
	}

	#progress(fraction) {
		if (!this.fill || !(fraction >= 0)) return
		this.target = Math.max(this.target, Math.min(fraction, 1))
		gsap.to(this.shown, {
			value: this.target,
			duration: this.fillDuration,
			ease: 'power2.out',
			overwrite: true,
			onUpdate: () => (this.fill.style.clipPath = `inset(0 ${(1 - this.shown.value) * 100}% 0 0)`),
		})
	}

	/** Resolves once everything has loaded and the fill has reached the end. */
	async ready(...also) {
		await Promise.all([this.loaded, ...also])
		this.#progress(1)
		await new Promise(resolve => gsap.delayedCall(this.fillDuration, resolve))
	}

	/** Fade the screen away. */
	hide() {
		if (!this.el) return Promise.resolve()
		return gsap.to(this.el, { autoAlpha: 0, duration: this.outDuration, ease: 'power2.inOut' }).then(() => this.el.remove())
	}
}
